import { Axios } from "@/utils/axios";
import { Article } from "./getArticleSearch";

interface ArticleMetaParam {
  type: string;
  category: string;
  index: number;
}

export interface ArticleMeta {
  flags: string[];
  views: number;
  is_scrapped: boolean;
  recommends: Article[];
}

export const getArticleMeta = async ({ type, category, index }: ArticleMetaParam) => {
  if (type === "tip" && category === "before" && index === 3) {
    const { data } = await Axios.get<ArticleMeta>(
      `/articles/${type}-${category}-funeral-expense/meta/`,
    );
    return data;
  } else {
    const { data } = await Axios.get<ArticleMeta>(`/articles/${type}-${category}-${index}/meta/`);
    return data;
  }
};
